import React, { useCallback } from 'react'
import { Col, Row } from 'react-bootstrap'
import { type IntegrationServiceId } from '../../../../common/integrations'
import { ROUTER_BASEPATH } from '../../../../common/constants'
import { useFinancialPlanningOnboardingBanner } from './useContactsPageOnboardingBanners'
import { ContactsEmptyState } from './ContactsEmptyState/ContactsEmptyState'
import { FinancialPlanningOnboardingBanner } from './FinancialPlanningOnboardingBanner/FinancialPlanningOnboardingBanner'

interface ContactsPageOnboardingBannersProps {
  contactCount: number | undefined
}

export const ContactsPageOnboardingBanners: React.FC<ContactsPageOnboardingBannersProps> = ({ contactCount }) => {
  const financialPlanningEmptyState = useFinancialPlanningOnboardingBanner()

  const postConnectRedirectPath = useCallback((serviceId: IntegrationServiceId) => {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
    return `${ROUTER_BASEPATH}/onboarding/post-connect/${serviceId}?returnTo=${returnTo}&intent=contacts`
  }, [])

  if (contactCount === 0) {
    return (
      <Row className='zocks-mb-2'>
        <Col className='d-flex justify-content-center'>
          <ContactsEmptyState postConnectRedirectPath={postConnectRedirectPath} />
        </Col>
      </Row>
    )
  }

  if (contactCount && contactCount > 0 && !financialPlanningEmptyState.isFetching && financialPlanningEmptyState.shouldShow) {
    return (
      <Row className='zocks-mb-2'>
        <Col>
          <FinancialPlanningOnboardingBanner onDismiss={financialPlanningEmptyState.dismiss} />
        </Col>
      </Row>
    )
  }

  return null
}
